export const StorageKeys = {
  AccessToken: 'access_token',
  RefreshToken: 'refresh_token',
  AuthData: 'auth_data',
  Profile: 'profile',
  IsRemember: 'is_remember',
  ShoppingCart: 'shopping_cart',
};
